import styled from 'styled-components';

export const StyledWrapper = styled.div<{ labelMarginBottom: number }>`
  margin: 0 0 ${({ labelMarginBottom }) => labelMarginBottom}px 0;
  display: block;
  border: 0;
  padding: 0;
  min-width: 0;
  width: 100%;
`;

export const StyledLabel = styled.label<{ grouped: boolean; boldLabel: boolean }>`
  font-size: ${({ theme }) => theme.fontSize.base}px;
  display: flex;
  font-weight: ${({ grouped, boldLabel }) => (grouped || !boldLabel) ? 'normal' : 'bold'};
  margin-bottom: 12px;
  width: 100%;
`;

export const StyledTip = styled.span`
  margin-top: -3px;
  margin-left: 4px;
  margin-bottom: -8px;
  font-weight: normal;
`;
